import React from 'react';
import { MessageCircle } from 'lucide-react';
import { CONSULTATION_LABEL } from '../../lib/specialist/pranicHealing';

export const ConsultationBadge = ({ testId = 'consultation-badge' }) => (
  <span className="sp-badge" data-testid={testId}>
    <MessageCircle size={16} aria-hidden="true" />
    {CONSULTATION_LABEL}
  </span>
);
